import get from 'lodash/get';

export const selectStatus = (state) => get(state, 'settings.twoFactor.status', 'disabled'); // api returns: disabled, requested, confirmed.

export const selectMessage = (state) => get(state, 'settings.twoFactor.message', '');

export const selectError = (state) => get(state, 'settings.twoFactor.error', false);

export const selectChecked = (state) => get(state, 'settings.twoFactor.checked', false);

// Whether the user actively touched the checkbox in this session, vs. `checked` just
// reflecting a freshly-fetched server status (see GET_SETTINGS_TWO_FACTOR_SUCCESS).
export const selectToggledByUser = (state) => get(state, 'settings.twoFactor.toggledByUser', false);

// null: nothing to save. 'confirm': turning 2FA on (or finishing setup). 'disable': turning 2FA off.
export const selectTwoFactorPendingAction = (state) => {
  const checked = selectChecked(state);
  const status = selectStatus(state);
  const toggledByUser = selectToggledByUser(state);
  // Do NOT trigger on checked && status === 'disabled': that's the transient window while
  // requestTwoFactor() is still in flight, and confirming there would send an empty secret.
  if (checked && status === 'requested') return 'confirm';
  if (!checked && status === 'confirmed') return 'disable';
  // A dangling, never-confirmed 'requested' status always reports checked=false on refetch
  // (see reducer), even if the user never touched the toggle this session. Only treat it as
  // "cancel this setup" when the user actually unchecked it themselves — otherwise opening
  // Preferences for an unrelated change (e.g. email) would silently disable it on Save.
  if (!checked && status === 'requested' && toggledByUser) return 'disable';
  return null;
};
